import * as React from 'react'

import { cn } from '@/lib/utils'

interface SeparatorProps extends React.HTMLAttributes<HTMLDivElement> {
  orientation?: 'horizontal' | 'vertical'
  align?: 'left' | 'center' | 'right'
  children?: React.ReactNode
}

const Separator = React.forwardRef<HTMLDivElement, SeparatorProps>(
  ({ className, orientation = 'horizontal', align = 'center', children, ...props }, ref) => {
    if (children) {
      const textAlignment = {
        left: 'justify-start',
        center: 'justify-center',
        right: 'justify-end',
      }

      return (
        <div
          ref={ref}
          className={cn(
            'relative flex items-center',
            orientation === 'horizontal' ? 'w-full' : 'h-full flex-col',
            textAlignment[align],
            className
          )}
          {...props}
        >
          <div className="border-border flex-1 border-t" />
          {children && <div className="text-muted-foreground px-3 text-sm">{children}</div>}
          <div className="border-border flex-1 border-t" />
        </div>
      )
    }

    return (
      <div
        ref={ref}
        className={cn(
          'bg-border shrink-0',
          orientation === 'horizontal' ? 'h-[1px] w-full' : 'h-full w-[1px]',
          className
        )}
        {...props}
      />
    )
  }
)
Separator.displayName = 'Separator'

export { Separator }
